export const Lotus = ({ className = "w-8 h-8", strokeWidth = 1.4 }) => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M24 40c-6-4-9-9-9-15 3 1 5 3 6 5-1-6 0-11 3-15 3 4 4 9 3 15 1-2 3-4 6-5 0 6-3 11-9 15z" />
    <path d="M10 32c4 3 9 5 14 5s10-2 14-5" />
    <path d="M14 40h20" />
  </svg>
);

export const Fish = ({ className = "w-8 h-8", strokeWidth = 1.4 }) => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M6 24c6-8 14-12 22-12 6 0 10 4 14 8l-6 4 6 4c-4 4-8 8-14 8-8 0-16-4-22-12z" />
    <circle cx="34" cy="22" r="1.4" fill="currentColor" stroke="none" />
    <path d="M16 18c3 2 3 10 0 12" />
  </svg>
);

export const SunMotif = ({ className = "w-8 h-8", strokeWidth = 1.4 }) => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="8" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
      <line
        key={a}
        x1={24 + 12 * Math.cos((a * Math.PI) / 180)}
        y1={24 + 12 * Math.sin((a * Math.PI) / 180)}
        x2={24 + 17 * Math.cos((a * Math.PI) / 180)}
        y2={24 + 17 * Math.sin((a * Math.PI) / 180)}
      />
    ))}
  </svg>
);

export const AlpanaCorner = ({ className = "w-24 h-24", strokeWidth = 1.2 }) => (
  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M4 96 C 4 50, 20 20, 60 8" />
    <path d="M16 96 C 16 60, 32 34, 70 20" />
    <path d="M60 8 q 6 10 -4 14 q 12 2 14 12" />
    <circle cx="78" cy="30" r="3" />
    <circle cx="88" cy="44" r="2" />
    <path d="M30 70 q 8 -2 10 6 q -8 2 -10 -6z" />
    <path d="M44 52 q 8 -2 10 6 q -8 2 -10 -6z" />
    <circle cx="20" cy="84" r="2" />
  </svg>
);

export const KanthaStitch = ({ className = "w-full" }) => (
  <div className={`kantha-line ${className}`} aria-hidden="true" />
);

export const PaisleyMotif = ({ className = "w-8 h-8", strokeWidth = 1.4 }) => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M30 6c-9 2-16 9-16 19 0 9 6 15 13 15 6 0 10-4 10-9 0-4-3-7-7-7-3 0-5 2-5 4" />
    <circle cx="25" cy="28" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);
